export default {
  tables_download: 'Download',
  tables_delete: 'Delete',
  tables_view: 'View',
  tables_edit: 'Edit',
  tables_impersonate: 'Impersonate'
};
